<div *ngIf="step === 1" class="dialog-container">

    <i class="fa-solid fa-circle-exclamation fs-40px mb-4" style="color: gold;"></i>
    <p class="bold-text" >{{message}}</p>
    <p class="single-text">{{description}}</p>
    <div class="controls-container">
        <button class="btn btn-secondary" (click)="closeDialog()">Cancelar</button>
        <button class="btn btn-primary" [disabled]="loadingModal" (click)="save()">
            {{confirmButton}}
        </button>
    </div>
</div>
